// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IButtonStyles } from "@fluentui/react";
import type { IIconStyles } from "@fluentui/react/lib/Icon";
import type { IStyle } from "@fluentui/react/lib/Styling";
import { concatStyleSets } from "@fluentui/react/lib/Styling";
import { memoizeFunction } from "@fluentui/react/lib/Utilities";

import type { AppGalleryStyles } from "@1js/acui-gallery";

export interface AppIconGalleryStyles {
  Icon: IStyle;
  tableCellStyles: IStyle;
}

export const iconGalleryButtonWidth = 68;

const fullGalleryButtonStyles: IButtonStyles = {
  root: {
    boxSizing: "border-box",
    height: 60,
    width: iconGalleryButtonWidth,
    padding: 0,
    borderTopWidth: 4,
    borderBottomWidth: 4,
    borderLeftWidth: 4,
    borderRightWidth: 4,
  },
};

export const iconTextStyles: IStyle = {
  margin: "0px 3px",
  textOverflow: "ellipsis",
  overflowX: "hidden",
};

export const previewIconStyles: IIconStyles = {
  root: {
    height: 20,
    width: 20,
  },
};

export const fullIconGalleryStyles: IIconStyles = {
  root: {
    height: 48,
    width: 48,
  },
};

/**
 * Get the styling for the full gallery
 * @param { Partial<AppGalleryStyles> } customStyles - Optional, custom styles to apply to gallery
 */
export const getIconFullGalleryStyles = memoizeFunction(
  (customStyles?: Partial<AppGalleryStyles>): Partial<AppGalleryStyles> => {
    return {
      ...customStyles,
      galleryButtonInExpanded: concatStyleSets(
        fullGalleryButtonStyles,
        customStyles && customStyles.galleryButtonInExpanded
      ),
    };
  }
);
